import React, { Component } from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { HashRouter, Route, Switch } from 'react-router-dom';
import * as actionCreators from './store/actions';
import { connect } from 'react-redux';
import { LoginComponent } from './components/login';
import { StatisticsComponent } from './components/stats';
import Navbar from './components/nav';
import Patients from './components/bcp';
import Calendar from './components/calendar';
import { ExportComponent } from './components/export';

const LoggedIn = () => (
  <div>You're logged in</div>
);

class App extends Component {
  componentWillMount() {
    this.props.fetchSession();
  }
  render() {
    var component = <LoginComponent />;
    console.log("APP", this.props.session);
    if (this.props.session.logged_in) {
      component = (
        <HashRouter>
          <div>
            <Navbar />
            <Switch>
              <Route path="/stats" component={StatisticsComponent} />
              <Route path="/patients" component={Patients} />
              <Route path="/calendar" component={Calendar} />
              <Route path="/export" component={ExportComponent} />
              <Route path="/" component={LoggedIn} />
            </Switch>
          </div>
        </HashRouter>
      )
    }
    return (
      <div className="container">
        {component}
      </div>
    );
  }
}

const selector = (state) => ({
  session: state.session.session
});

export default connect(selector, actionCreators)(App);



// WEBPACK FOOTER //
// ./src/App.js